export default {
  workOrder: "工单编号",
  oralReviewCode: "点评编号",
  status: "当前状态",
  studentLeval: "学生评级",
  isAnswered: "是否回复",
  distributionTime: "分配时间",
  orderTakingTime: "接单时间",
  timeoutStatus: "超时状态",
  commentTimeout: "已超时",
  commentNotTimeout: "未超时",
  commentCompletionTime: "批改完成时间",
  distributionStartTime: "开始分配时间",
  distributionEndTime: "结束分配时间",
  publishStartTime: "开始发布时间",
  publishEndTime: "结束发布时间",
  search: "查询",
  clear: "清空",
  tobeCorrected: "待批改",
  correcting: "批改中",
  toBeAssigned: "待分配",
  correctTeacher: "批改老师",
  assign: "分配",
  reAssign: "重新分配",
  reback: "已打回",
  recorrect: "待重批",
  // comment: "已评价",
  all: "全部",
  index: "序号",
  overTime: "超时时间",
  service: "服务",
  studentComments: "学生评价",
  answerContent: "回复内容",
  operation: "操作",
  detail: "详情",
  comment: "点评",
  viewComments: "查看评价",
  serviceTitle: "服务",
  oralQuestion: "口语题目",
  userInfo: "用户信息",
  topic: "话题",
  question: "问题",
  userRecoring: "用户录音",
  oralScore: "口语评分",
  oralComment: "口语点评",
  pronunciation: "发音",
  vocabulary: "词汇",
  grammar: "语法",
  fluency: "流利度连贯性",
  composite: "综合",
  pastScore: "过往评分",
  pronunciationTip: "发音提升建议",
  vocabularyTip: "词汇多样性提升建议",
  grammarTip: "语法多样性及准确性提升建议",
  fluencyTip: "流利度连贯性提升建议",
  wrongWords: "错误单词纠正",
  wrongWordsRule:
    "发音错误单词纠正，逐个填写，用英文逗号','隔开，逗号后不加空格。如：house,exit,ground",
  preparationTips: "全面备考建议",
  userComments: "用户评价",
  firstOrder: "首单",
  serviceTypes: {
    "0": "快速点评",
    "1": "精细点评",
    "2": "答案升级",
    "3": "模考评分",
    "4": "加购答案",
    "5": "口语模考-升级"
  },
  answerCustom: "答案定制",
  wrongWordValidTip: "错误单词只能包含单词和英文逗号",
  completeTip: "请完整填写报告内容",
  reportCompleteTip: "报告点评内容为空无法提交，请完善报告内容",
  wordLimit: "报告字数不得多于10000字",
  lastScore: "上次成绩",
  targetScore: "目标分数",
  examDate: "考试时间",
  points: "分",
  save: "保存",
  handleReback: "打回",
  review: "提交审核",
  returnReason: "打回原因",
  returnReasonRequired: "打回原因不能为空",
  reasonTip: "请输入原因",
  scoreRequiredTip: "批改报告未填写评分哦！请填写后继续提交",
  optDesc: "您确定要{str}点评报告吗?",
  statusMap: {
    "0": "批改中",
    "1": "已打回",
    "2": "待审核",
    "3": "已发布",
    "4": "已评价",
    "5": "待重批",
    "6": "已取消"
  },
  teacherId: "教师ID",
  teacherName: "教师姓名",
  workRole: "接单人角色",
  allocation: "分配限额",
  priority: "优先级",
  allocateStatus: "自动分配状态",
  edit: "修改",
  stop: "关闭",
  effect: "开启",
  delete: "删除",
  stopTip: "“关闭”后，系统将不会再自动派单给该教师！",
  effectTip: "“开启”后，系统将自动派单给该教师！",
  deleteTip: "“删除”后，系统将不会再自动派单给该教师！",
  ruleForm: {
    role: "接单角色",
    institution: "所属机构",
    teacher: "选择老师",
    quota: "分配限额",
    type: "服务类型",
    priority: "优先级",
    remark: "备注"
  },
  placeholder: {
    input: "请输入内容",
    select: "请选择"
  },
  priorityLevel: {
    priority: "优先",
    hign: "高",
    middle: "中",
    low: "低",
    empty: "无"
  },
  day: "天",
  roleOptions: {
    institution: "机构",
    teacher: "教师"
  },
  dialogTitle: {
    add: "新增派单规则",
    update: "修改派单规则",
    tip: "操作提示"
  },
  create: "新增",
  switchText: "接单开关",
  optSuccess: "操作成功!",
  quotaCheckTip: "请填写1～{num}的数字",
  currentReceiveCount: "当前接单数"
};



// WEBPACK FOOTER //
// ./src/i18n/zh-CN/oralComment.js